export default __webpack_public_path__ + "static/media/chat_selected.6c977ea1.svg";